import React, { useState, useEffect } from "react";
import OngoingJobInformation from "./OngoingJobInformation";
import CustomTable from "../../../../Components/Table";
import { useProjectProvider } from "../../../../Providers/Client/Project";
import { Avatar, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import { stringAvatar } from "../../../../Utils/avatar";
import api from "../../../../Utils/api";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const headCells = [
  { disablePadding: true, label: "Project Date" },
  { disablePadding: false, label: "Title" },
  { disablePadding: false, label: "Description" },
  { disablePadding: false, label: "Consultant" },
  { disablePadding: false, label: "Vendors" },
  { disablePadding: false, label: "Time Tracked" },
  { disablePadding: false, label: "Status" },
];

export default function ProjectInformation({ setProjectStatus }) {
  const [jobId, setJobId] = useState();
  const [rows, setRows] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const { fetchJobsWithTimeTracked, fetchAllProjectsWithProfiles } = useProjectProvider();
  const [project, setProject] = useState()

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  const { projectid } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    async function fetchData() {
      const res = await api.get(`/project/get-project-by-id/${projectid}`)

      console.log(res.data.result)
      setProject(res.data.result)
    }

    fetchData()
  }, [])

  const location = useLocation()

  useEffect(() => {
    if (projectid) {
      fetchJobsWithTimeTracked(projectid).then(setRows);
    }
  }, [projectid]);

  const CustomRow = ({ row }) => {
    return (
      <TableRow
        hover
        className="cursor-pointer"
        onClick={() => {
          navigate(`/dashboard/jobscard/${row.id}`, { state: { from: location } })
        }}
      >
        <TableCell>{moment.utc(row.createdAt).format("DD/MM/YYYY")}</TableCell>
        <TableCell className="truncate max-w-[250px]">{row.title}</TableCell>
        <TableCell className="truncate max-w-[250px]">{row.description}</TableCell>
        <TableCell>
          {row.consultant ? (
            <Avatar
              {...stringAvatar(
                `${row.consultant.firstName} ${row.consultant.lastName}`
              )}
            />
          ) : null}
        </TableCell>
        <TableCell>
          {row.vendor ? (
            <Avatar
              {...stringAvatar(
                `${row.vendor.firstName} ${row.vendor.lastName}`
              )}
            />
          ) : null}
        </TableCell>
        <TableCell>
          {row.timeTracked
            ? `${row.timeTracked.hours}`.padStart(2, "0") +
            ":" +
            `${row.timeTracked.minutes}`.padStart(2, "0")
            : ""}
        </TableCell>
        <TableCell>
          <span
            className="px-2 py-1 rounded-sm text-sm"
            style={{
              backgroundColor:
                row.Status === "Inprogress"
                  ? "rgba(246, 104, 104, 0.2)"
                  : row.Status === "Invoice Ready"
                    ? "rgba(229, 197, 28, 0.2)"
                    : "rgba(19, 149, 136, 0.2)",
              color:
                row.Status === "Inprogress"
                  ? "rgba(246, 104, 104, 1)"
                  : row.Status === "Invoice Ready"
                    ? "rgba(229, 197, 28, 1)"
                    : "rgba(19, 149, 136, 1)",
            }}
          >
            {row.status}
          </span>
        </TableCell>
      </TableRow>
    );
  };
  return (
    <div className="">
      {!jobId ? (
        <>
          <div className="flex flex-row space-x-4 justify-between">
            <div className="flex flex-col grow bg-white rounded-lg font-[Roboto] p-4">
              <span
                className="cursor-pointer mb-4"
                onClick={() => {
                  navigate("/dashboard")
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                  />
                </svg>
              </span>
              <span className="flex flex-row text-gray-700">
                <span className="mr-8 font-medium">Name:</span>
                <span className="text-sm">{project?.title}</span>
              </span>
              <span className="flex flex-row text-gray-700">
                <span className="mr-8 font-medium">Description:</span>
                <div className="flex flex-col space-y-1">
                  <div className="text-justify text-sm">
                    {isExpanded ? project?.description?.split(' ')?.join(' ') : project?.description?.split(' ')?.slice(0, 70)?.join(' ')}
                  </div>
                  {project?.description?.split(' ').length >= 70 && <div className="flex flex-row justify-start">
                    <button type="button" className="text-blue-400" onClick={toggleExpand}>
                      {isExpanded ? "See Less" : "See More"}
                    </button>
                  </div>}
                </div>
              </span>
            </div>
          </div>
          <div className="mt-4">
            <CustomTable
              title="List of Jobs"
              headCells={headCells}
              rows={rows}
              CustomRow={CustomRow}
            />
          </div>
        </>
      ) : (
        <OngoingJobInformation jobId={jobId} reset={() => setJobId()} />
      )}
    </div>
  );
}
